module.exports = __webpack_public_path__ + "media/images/lb/803-271bb35534535c97de07f44f60cd9784.svg";